<template>
  <content-dialog
    :visible.sync="modalVisible"
    scrollable
    max-width="500"
  >
    <!--<editor-fold desc="Dialog title">-->
    <template slot="dialogTitle">
      Switch yacht logistics status
    </template>
    <!--</editor-fold>-->

    <v-card-text class="pa-6">
      <v-row

        justify="space-between"
        align="center"
        class="mb-2"
      >
        <v-col
          class="grey--text text--darken-1"
        >
          New Status
        </v-col>
        <v-col class="shrink">
          <v-chip
            :color="statusData.color"
            dark
            class="text-uppercase"
          >
            {{ statusData.label }}
          </v-chip>
        </v-col>
      </v-row>
      <p>
        The yacht has been ordered and you are starting the logistics process for this yacht. Logistics department will
        know a plan has to be specified for this yacht.
      </p>
    </v-card-text>

    <template slot="dialogActions">
      <v-spacer />
      <v-btn
        text
        color="grey"
        @click="modalVisible = false"
      >
        Cancel
      </v-btn>
      <v-btn
        color="primary"
        @click="updateYacht"
      >
        <v-icon
          small
          left
        >
          check
        </v-icon>
        Confirm Pending Plan
      </v-btn>
    </template>
  </content-dialog>
</template>

<script>
  import Yacht from '@/models/Yacht'
  import ContentDialog from '@/components/helpers/Dialog'

  export default {
    name: 'PendingPlanStatusDialog',
    components: {
      ContentDialog
    },
    props: {
      visible: Boolean,
      yacht: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        statusData: Yacht.statusData[Yacht.STATUS_PENDING],
        submitting: false
      }
    },
    computed: {
      modalVisible: {
        get: function () {
          return this.visible
        },
        set: function (value) {
          this.$emit('update:visible', value)
        }
      },
      yachtDirty: {
        get: function () {
          return this.yacht
        },
        set: function (value) {
          this.$emit('update:yacht', value)
        }
      }
    },
    created() {
    },
    methods: {
      async updateYacht() {
        this.submitting = true

        let data = {
          status: this.statusData.key
        }

        try {
          this.yachtDirty = await Yacht.api.save(data, this.yachtDirty.id)
          this.modalVisible = false
          this.$store.dispatch('alert', {
            'text': 'Yacht logistics process started.',
            'color': 'success'
          })
        } catch (e) {
          this.$store.dispatch('alert', {
            'text': 'Something went wrong',
            'color': 'error'
          })
          throw e
        } finally {
          this.submitting = false
        }
      }
    }
  }
</script>
